import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useWallets = () => {
  const { wallets, activeWalletID, transactions, filters, promisedPayments } =
    useSelector((state) => state['finance/wallets'])

  const activeWallet = useMemo(
    () => wallets.data?.find(({ id }) => id === activeWalletID) ?? {},
    [activeWalletID],
  )

  const { currency: activeWalletCurrency = 'RUB' } = useMemo(
    () => activeWallet,
    [activeWallet],
  )

  return {
    activeWallet,
    wallets,
    promisedPayments,
    transactions,
    filters,
    activeWalletID,
    activeWalletCurrency,
  }
}
